// 8D, LPA, and FMEA-extended mock data

export const EIGHT_D_STEPS = [
  { code: "D0", label: "Emergency Response" },
  { code: "D1", label: "Team" },
  { code: "D2", label: "Problem Description" },
  { code: "D3", label: "Interim Containment" },
  { code: "D4", label: "Root Cause Analysis" },
  { code: "D5", label: "Choose & Verify PCA" },
  { code: "D6", label: "Implement & Validate" },
  { code: "D7", label: "Prevent Recurrence" },
  { code: "D8", label: "Closing" },
];

export const eightDStatusStyle = (s) => {
  const map = {
    open: { bg: "rgba(122,128,153,0.12)", border: "rgba(122,128,153,0.4)", color: "#9aa1b3", label: "OPEN" },
    "in-progress": { bg: "rgba(243,156,18,0.13)", border: "rgba(243,156,18,0.5)", color: "#f3b14a", label: "IN PROGRESS" },
    "pending-approval": { bg: "rgba(24,95,165,0.15)", border: "rgba(24,95,165,0.5)", color: "#5fa3e3", label: "PENDING APPROVAL" },
    closed: { bg: "rgba(39,174,96,0.13)", border: "rgba(39,174,96,0.5)", color: "#4ed084", label: "CLOSED" },
  };
  return map[s] || map.open;
};

export const eightDReports = [
  {
    id: "8D-2024-0041",
    title: "JIS Sequence Error Line 7 Body Shop",
    sourceIncident: "INC-2024-0891",
    customer: "BMW Regensburg",
    supplier: "Inteva Products",
    status: "in-progress",
    currentStep: "D4",
    progress: 4, // index of current step (D4 = 4)
    lastUpdated: "2024-03-15",
    internalRef: "8D-INT-2024-141",
    sourceOfIssue: ["Customer Complaint"],
    teamChampion: "M. Lehr",
    d0: {
      customer: { action: "Halt Line 7, switch to manual sequencing", start: "2024-03-12", end: "2024-03-12" },
      supplier: { action: "Inteva: deploy emergency ERP team", start: "2024-03-12", end: "2024-03-12" },
    },
    d1: [
      { role: "Team Champion / Accountable", name: "M. Lehr", function: "BMW Logistics" },
      { role: "8D Project Leader", name: "K. Horváth", function: "BMW QA Regensburg" },
      { role: "Team Member", name: "R. Szabó", function: "Inteva ERP Lead" },
      { role: "Team Member", name: "T. Bauer", function: "BMW JIS Center" },
    ],
    d2: {
      complaint: "JIS sequence delivery deviated from call-off by 14 positions on Line 7. Halt triggered at 10:28.",
      what: "Seat module sequence mismatch",
      when: "2024-03-12 10:28 CET",
      howMany: "47 units affected",
      howBig: "100% reject rate within the affected window",
      where: "Line 7 — Body Shop · BMW Regensburg",
      additional: "ERP sync between Inteva and BMW JIS Center lost upstream sequence call-off ID.",
    },
    d3: {
      customer: [
        { action: "Manual sequencing at JIS dock", responsible: "BMW JIS", date: "2024-03-12", evidence: "Photo log", effect: "70%" },
      ],
      supplier: [
        { action: "Inteva temp manual dispatch", responsible: "R. Szabó", date: "2024-03-12", evidence: "Email confirmation", effect: "80%" },
      ],
      affectedProducts: "47 units quarantined for re-sequence verification",
      traceability: "VIN-tracked, batch flagged in MES",
    },
    d4: {
      logbook: [
        { action: "ERP log dump", responsible: "R. Szabó", date: "2024-03-13", evidence: "ERP trace export" },
        { action: "Network packet analysis", responsible: "Inteva IT", date: "2024-03-13", evidence: "Wireshark capture" },
      ],
      possibleRoots: "ERP sync queue overflow, network packet loss, scheduling drift",
      whyProblem: ["Sequence mismatch", "ERP sent old sequence", "Queue not flushed", "No watchdog timer", "Missing redundancy"],
      finalRootCause: "ERP sync queue overflow at Inteva ERP — no watchdog on sequence dispatch causing stale orders to be processed.",
      whyEscape: ["Not detected at dock", "No automated sequence check", "Manual check daily only", "No T-2h validation", "No alarm threshold"],
      finalEscapeRoot: "JIS Center had no automated sequence pre-validation at T-2h before window.",
      category: ["Supplier Manufacturing", "Logistics/Shipping"],
      docs: "Inteva ERP-SYNC-DOC v3.2; BMW JIS Center procedure JIS-PROC-014",
    },
    d5: {
      problem: [
        { action: "Deploy ERP watchdog + auto-rollback", responsible: "Inteva IT", date: "2024-03-22", evidence: "Code deploy log", effect: "95%" },
      ],
      nonDetection: [
        { action: "Add T-2h pre-validation alarm at JIS dock", responsible: "BMW JIS", date: "2024-03-25", evidence: "MES rule config", effect: "90%" },
      ],
    },
    d6: { problem: [], nonDetection: [], validationDate: "", traceability: "" },
    d7: { current: [], future: [], earlyDetection: [] },
    d8: null,
  },
  {
    id: "8D-2024-0038",
    title: "Wiring Harness Buffer Depletion",
    sourceIncident: "INC-2024-0855",
    customer: "BMW Regensburg",
    supplier: "Leoni AG",
    status: "closed",
    currentStep: "D8",
    progress: 8,
    lastUpdated: "2024-03-10",
    internalRef: "8D-INT-2024-138",
    sourceOfIssue: ["Customer Complaint"],
    teamChampion: "T. Bauer",
    d2: { complaint: "Wiring harness inventory critically low — line stoppage 1.8h" },
    d4: { finalRootCause: "Leoni AG safety stock policy below 4h production buffer.", category: ["Supplier Manufacturing"] },
    d5: { problem: [{ action: "Set buffer to 8h production equivalent", responsible: "Leoni Planning", date: "2024-02-20", evidence: "WMS config", effect: "95%" }] },
    d8: {
      supplierCredits: "€55,800",
      supplierApprovedBy: "J. Falk",
      supplierFunction: "Leoni QA Lead",
      supplierDate: "2024-03-10",
      customerCredits: "€55,800",
      customerRequired: "€55,800",
      customerApprovedBy: "M. Lehr",
      shareBestPractices: true,
      businessCt: "BMW Logistics",
      customerDate: "2024-03-10",
    },
  },
  {
    id: "8D-2024-0035",
    title: "KLT Pool Imbalance Q1",
    sourceIncident: "INC-2024-0831",
    customer: "BMW Regensburg",
    supplier: "LPR Pooling",
    status: "pending-approval",
    currentStep: "D7",
    progress: 7,
    lastUpdated: "2024-03-08",
    internalRef: "8D-INT-2024-135",
    sourceOfIssue: ["Internal Manufacturing"],
    teamChampion: "C. Vogel",
    d2: { complaint: "KLT pool imbalance — 1,200 unit deficit forecast" },
    d4: { finalRootCause: "LPR return loop pickups not on milk-run schedule.", category: ["Logistics/Shipping"] },
    d5: { problem: [{ action: "Add KLT pickup to milk-run", responsible: "LPR Ops", date: "2024-03-01", evidence: "Route plan v4", effect: "85%" }] },
  },
];

// ============== LPA AUDIT REQUESTS ==============

export const LPA_STANDARDS = ["VDA 6.3", "VDA 6.8", "IATF 16949"];

export const LPA_ROUTING = {
  s1: { type: "third-party", label: "Third-Party" },
  s2: { type: "customer", label: "Customer" },
  s3: { type: "internal", label: "Internal" },
  s4: { type: "internal", label: "Internal" },
};

export const auditorTypeStyle = (type) => {
  const map = {
    internal: { bg: "rgba(24,95,165,0.15)", border: "rgba(24,95,165,0.5)", color: "#5fa3e3", label: "INTERNAL" },
    customer: { bg: "rgba(243,156,18,0.13)", border: "rgba(243,156,18,0.5)", color: "#f3b14a", label: "CUSTOMER" },
    "third-party": { bg: "rgba(142,68,173,0.18)", border: "rgba(142,68,173,0.55)", color: "#c89adb", label: "THIRD-PARTY" },
  };
  return map[type] || map.internal;
};

export const lpaStatusStyle = (s) => {
  const map = {
    pending: { bg: "rgba(122,128,153,0.12)", border: "rgba(122,128,153,0.4)", color: "#9aa1b3", label: "PENDING" },
    scheduled: { bg: "rgba(24,95,165,0.15)", border: "rgba(24,95,165,0.5)", color: "#5fa3e3", label: "SCHEDULED" },
    "in-progress": { bg: "rgba(243,156,18,0.13)", border: "rgba(243,156,18,0.5)", color: "#f3b14a", label: "IN PROGRESS" },
    completed: { bg: "rgba(39,174,96,0.13)", border: "rgba(39,174,96,0.5)", color: "#4ed084", label: "COMPLETED" },
  };
  return map[s] || map.pending;
};

export const lpaRequests = [
  {
    id: "LPA-2024-0018",
    standard: "VDA 6.3",
    sourceIncident: "INC-2024-0891",
    severity: "s1",
    auditorType: "third-party",
    auditor: "TÜV Süd · audit@tuev-sued.com",
    scheduledDate: "2024-03-28",
    status: "scheduled",
    requestedBy: "M. Lehr",
    requestedAt: "2024-03-13 09:14",
    scope: "JIS sequence integrity, ERP redundancy, T-2h validation gates at JIS Center.",
    notifications: [
      { channel: "Email", target: "audit@tuev-sued.com", at: "2024-03-13 09:14" },
      { channel: "In-app", target: "TÜV Süd · audit desk", at: "2024-03-13 09:14" },
    ],
  },
  {
    id: "LPA-2024-0017",
    standard: "VDA 6.8",
    sourceIncident: "INC-2024-0888",
    severity: "s1",
    auditorType: "customer",
    auditor: "BMW SQE Team · sqe@bmw.com",
    scheduledDate: "2024-03-25",
    status: "in-progress",
    requestedBy: "T. Bauer",
    requestedAt: "2024-03-11 14:02",
    scope: "Wiring harness logistics chain & supplier buffer policies.",
    notifications: [
      { channel: "Email", target: "sqe@bmw.com", at: "2024-03-11 14:02" },
      { channel: "In-app", target: "BMW SQE", at: "2024-03-11 14:02" },
    ],
  },
  {
    id: "LPA-2024-0015",
    standard: "IATF 16949",
    sourceIncident: "INC-2024-0871",
    severity: "s3",
    auditorType: "internal",
    auditor: "K. Horváth · k.horvath@bmw.com",
    scheduledDate: "2024-03-20",
    status: "completed",
    requestedBy: "C. Vogel",
    requestedAt: "2024-03-05 11:30",
    scope: "Packaging pool balance and return-loop standard work.",
    notifications: [
      { channel: "Email", target: "k.horvath@bmw.com", at: "2024-03-05 11:30" },
      { channel: "In-app", target: "K. Horváth", at: "2024-03-05 11:30" },
    ],
  },
];

// Pre-audit logbook generator — pulls events from incident
export const buildPreAuditLogbook = (incident) => {
  if (!incident) return [];
  const entries = [];
  (incident.timeline || []).forEach((ev) => {
    let actor = "System";
    let action = "EVENT";
    let detail = ev.text;
    if (ev.dot === "red" && /opened/i.test(ev.text)) action = "OPENED";
    else if (ev.dot === "red" && /breach/i.test(ev.text)) action = "SLA BREACH";
    else if (ev.dot === "red" && /escalated/i.test(ev.text)) action = "ESCALATED";
    else if (ev.dot === "blue") action = "ACKNOWLEDGED";
    else if (ev.dot === "amber") action = "SLA WARNING";
    else if (ev.dot === "green") action = "RESOLVED";
    entries.push({ time: ev.time, actor, action, detail });
  });
  (incident.comments || []).forEach((c) => {
    entries.push({ time: c.time, actor: c.author, action: "COMMENT", detail: c.text });
  });
  // Sort by time
  entries.sort((a, b) => a.time.localeCompare(b.time));
  return entries;
};

export const actionBadgeColor = (action) => {
  const map = {
    OPENED: "#185FA5",
    ACKNOWLEDGED: "#27d3b8",
    "SLA WARNING": "#f39c12",
    "SLA BREACH": "#E24B4A",
    ESCALATED: "#E24B4A",
    COMMENT: "#9198b0",
    "8D OPENED": "#8e44ad",
    RESOLVED: "#27ae60",
    CLOSED: "#636880",
  };
  return map[action] || "#9198b0";
};
